import $ from 'jquery';
import Swiper, { Navigation } from 'swiper';

Swiper.use( [Navigation] );

/**
 * Features list
 */
new Swiper( '.features__swiper .swiper-container', {
	slidesPerView: 1,
	breakpoints: {
		768: {
			slidesPerView: 2,
			spaceBetween: 20
		},
		992: {
			slidesPerView: 3,
			spaceBetween: 30
		}
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
} );

/**
 * Testimonials list
 */
new Swiper( '.testimonials__swiper .swiper-container', {
	slidesPerView: 1,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	}
} );

/**
 * Plan prices
 */
$( window ).ready(() => {
	$( '.plans-table__foot' ).each( ( index, el ) => {
		let container = el.querySelector( '.swiper-container' );

		if (! container) return;

		new Swiper( container, {
			loop: true,
			autoHeight: true,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		} );
	} );
} );

